export default __webpack_public_path__ + "static/media/empty-cart.db905d1f.png";